/**
 * Images marked "To deletion" (869fhgjpg) → one exclude request per provider,
 * at most `limit` ids each. The endpoint takes 500, but the ids ride in the
 * query string: 100 keeps the URL well under proxy limits. Only gup rows:
 * the backend would skip the rest anyway, and a provider-less row can't be
 * sent at all, so both are counted in `left` for the caller to report.
 */
export function eraseBatches(images, limit = 100) {
    const byProvider = new Map();
    let left = 0;
    for (const img of images ?? []) {
        if (!img.toDelete) continue;
        if (img.origin !== 'gup' || img.providerId == null) { left += 1; continue; }
        const ids = byProvider.get(img.providerId) ?? [];
        ids.push(img.id);
        byProvider.set(img.providerId, ids);
    }
    const batches = [];
    for (const [providerId, ids] of byProvider) {
        for (let i = 0; i < ids.length; i += limit) batches.push({ providerId, ids: ids.slice(i, i + limit) });
    }
    return { batches, left };
}
